import React, { useEffect } from 'react';
import type { AlertColor } from '@mui/material/Alert';
import { useNotify } from '@routes-plan/ui';

interface AlertSnackbarProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  handleClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

/**
 * Avisos de las pantallas que usan `showAlert`: se muestran con `useNotify` de @routes-plan/ui (mismo aviso
 * que el panel y el portal). Mantiene la API de antes: al abrirse, entrega el aviso y queda cerrado de nuevo.
 * Éxito e información se cierran solos; advertencias y errores quedan más tiempo.
 */
const AlertSnackbar: React.FC<AlertSnackbarProps> = ({ open, message, severity, handleClose }) => {
  const notify = useNotify();

  useEffect(() => {
    if (!open) return;
    if (message) {
      const text = <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{message}</span>;
      if (severity === 'warning') notify.warning(text, { duration: 9000 });
      else notify[severity](text);
    }
    handleClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, message, severity]);

  return null;
};

export default AlertSnackbar;
